import 'Assets/styles/default/pages/focalPoint/FocalPointManagePointsStyles.less';
import React from 'react';
import {
    VertModal,
    VertButton,
    Typography
} from '@vertem-core/vertice-ds';
import { Col, Row } from 'antd';
import AllocatePointsSuccessIcon from '../Icons/AllocatePointsSuccess';
import { useSelector } from 'react-redux';

const AllocatePointsSuccessModal = ({ isOpen, onClose, solicitationNumber }) => {
    const Catalog = useSelector(({ Catalog: data }) => data);
    const { currencyConfiguration: { pointsName }, } = Catalog;
    return (
        <VertModal
            destroyOnClose={true}
            open={isOpen}
            closable={false}
            onCancel={() => {
                onClose();
            }}
        >
            <Row justify={'center'}
                gutter={[16, 16]}
            >
                <Col span={24}>
                    <Row justify={'center'}>
                        <AllocatePointsSuccessIcon />
                    </Row>
                </Col>

                <Col span={24}>
                    <Row justify={'center'}>
                        <Typography.Text className="modal-allocate-success-text-main" >
                            Você distribuiu os {pointsName} com sucesso!
                        </Typography.Text>
                        <Typography.Text className="modal-allocate-success-text-main">
                            N° da distribuição: {solicitationNumber}
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24}>
                    <Row justify={'center'}>
                        <Typography.Text className="modal-allocate-success-text-sub">
                            Para acompanhar o status da sua distribuição
                        </Typography.Text>
                        <Typography.Text className="modal-allocate-success-text-sub">
                            vá até o histórico de distribuição de {pointsName}.
                        </Typography.Text>
                    </Row>
                </Col>

                <Col span={24} className='modal-allocate-success-container-button'>
                    <VertButton
                        type="highlight"
                        size="default"
                        className='button-historic-redirect button-focal-point width-100'
                        onClick={() => { onClose() }}
                    >
                        Entendi
                    </VertButton>
                </Col>

            </Row>

        </VertModal >
    );
};

export default AllocatePointsSuccessModal;
